import React, { useState } from 'react';
import {Carousel} from 'react-responsive-carousel'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
import '../css/carousel.css'
//@use 'styles/_colors.scss'; // assuming a styles directory under src/
//@use '~react-responsive-carousel/carousel'; // loading a css file from the nprogress node module
//var Carousel = require('react-responsive-carousel').Carousel;
const SJCarousel = (props) => {
   const onChange = (o) =>{
       console.log('onChange called')
       console.log(o)

   }
   const onClickItem = (o) =>{
    console.log('onClickItem called')
    console.log(o)

}

const onClickThumb = (o) =>{
    console.log('onClickThumb called')
    console.log(o)

}

    return (
        <Carousel showThumbs={false} showArrows={true} onChange={onChange} onClickItem={onClickItem} onClickThumb={onClickThumb}>
            <div>
              <img  src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                
                <p className="legend">Legend 1</p>
            </div>
            <div>
            <img  src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`} alt="Carpet Grass" />
              
                <p className="legend">Legend 2</p>
            </div>
            <div>
            <img  src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`} alt="Carpet Grass" />
              
                <p className="legend">Legend 3</p>
            </div>
            <div>
                <img  src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`} alt="Carpet Grass" />
              
                <p className="legend">Legend 4</p>
            </div>
            <div>
                 <img  src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`} alt="Carpet Grass" />
              
                <p className="legend">Legend 5</p>
            </div>
            <div>
                 <img  src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`} alt="Carpet Grass" />
              
                <p className="legend">Legend 6</p>
            </div>
        </Carousel>
    );

    

    /*
    return (
        <Carousel showArrows={true} onChange={onChange} onClickItem={onClickItem} onClickThumb={onClickThumb}>
            <div>
                <img src="../css/assets/1.jpeg" />
                <p className="legend">Legend 1</p>
            </div>
            <div>
                <img src="../css/assets/2.jpeg" />
                <p className="legend">Legend 2</p>
            </div>
            <div>
                <img src="../css/assets/3.jpeg" />
                <p className="legend">Legend 3</p>
            </div>
            <div>
                <img src="../css/assets/4.jpeg" />
                <p className="legend">Legend 4</p>
            </div>
            <div>
                <img src="../css/assets/5.jpeg" />
                <p className="legend">Legend 5</p>
            </div>
            <div>
                <img src="../css/assets/6.jpeg" />
                <p className="legend">Legend 6</p>
            </div>
        </Carousel>
    );
    */
}

export default SJCarousel;